// gkc_hash_code : 01FJGW9AB4VKN1PM0CVCZY1PTE
export enum LocalStorageKey {
  USER_INFO = "USER_INFO",
  userId = "userId",
  blockPrograms = "blockPrograms",
  userName = "userName",
  cartIn = "cartIn",
}
export default class LocalStorage {
  public static get = (key: LocalStorageKey) => {
    return localStorage.getItem(key);
  };

  public static set = (key: LocalStorageKey, value: string) => {
    return localStorage.setItem(key, value);
  };

  public static remove = (key: LocalStorageKey) => {
    return localStorage.removeItem(key);
  };
}
